import * as sdk from '../sdk';
import { browserHistory } from 'react-router';
import { storeSpecificErrors } from './commonActions';
import { toast } from 'react-toastify';

export const clearGdpr = () => {
  return {
    type: 'CLEAR_GDPR'
  }
}

export const storeGdpr = (payload) => {
  return {
    type: 'STORE_GDPR',
    payload
  }
}

export const requestGdprDeletion = (formData) => {
  return (dispatch, getState) => {
    return sdk.requestGdprDeletion(getState().auth.jwToken, formData)
      .then(resp => { 
        browserHistory.push("/logout");
        toast("Account successfully deleted!", {type: toast.TYPE.INFO});
      })
      .catch(err => {
        dispatch(storeSpecificErrors("error_gdpr_deletion", err.response.data));
      })
  }
}

export const requestGdprInformation = (formData) => {
  return (dispatch, getState) => {
    return sdk.requestGdprInformation(getState().auth.jwToken, formData)
      .then(resp => {
        dispatch(storeGdpr(resp.data.data))
        browserHistory.push('/gdpr/view');
      })
      .catch(err => {
        dispatch(storeSpecificErrors("error_gdpr_request", err.response.data));
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/gdprActions.js